import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ITableColumnHeader } from '../../../models/table-column-header';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../providers/api.service';
import { SM_CONSTANTS } from '../../../shared/constants/sm-constants';
import { MatDialog } from '@angular/material/dialog';
import { AddNewBookingComponent } from 'src/app/shared/components/add-new-booking/add-new-booking.component';
import { ManageBookingComponent } from 'src/app/shared/components/manage-booking/manage-booking.component';
import { AssignJobComponent } from 'src/app/shared/components/assign-job/assign-job.component';
import { InvoiceComponent } from 'src/app/shared/components/invoice/invoice.component';
import { CustomiseBookingComponent } from 'src/app/shared/components/customise-booking/customise-booking.component';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { BookingDetailsComponent } from 'src/app/shared/components/booking-details/booking-details.component';
import { AddEditTaxGstComponent } from 'src/app/shared/components/add-edit-tax-gst/add-edit-tax-gst.component';
import { AddEditDiscountsComponent } from 'src/app/shared/components/add-edit-discounts/add-edit-discounts.component';
import { MessagingService } from 'src/app/providers/messaging.service';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';

@Component({
  selector: 'sm-discounts',
  templateUrl: './discounts.component.html',
  styleUrls: ['./discounts.component.scss']
})
export class DiscountsComponent implements OnInit, OnDestroy {
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
 entityHashId: string = ''
  discountData: any = []
  toShowCheck: number = 1
  private _apiSubscription: Subscription;
  loader: boolean = false
  constructor(private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService, public _modelRef: MatDialog,  private loaderService: LoaderServiceService,private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{

      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_BILL_DISCOUNT){
        this.discountData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            this.discountData.push(element)
            this.toShowCheck = this.discountData[0].discountStatus
          });
        }
        else{
          this.toShowCheck = 0
        }
        this.loaderService.showLoader = false
        this.loader = false
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_BILL_DISCOUNT){
        if(resData.result){
          this._apiService.getBillDiscount(this.entityHashId)
        }
      }

    });
    if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
      this.messagingService.requestPermission();
    }
   }

  ngOnInit(): void {
  
    // this.loader = true  
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    }) 
    this.loaderService.showLoader = true
    this.loader = true
    this._apiService.getBillDiscount(this.entityHashId)



  }
  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  navigate(){
    this.router.navigate(['../'], {relativeTo: this.route ,  queryParamsHandling: 'preserve'})
  }

  openconfigureDiscount(){
    this.router.navigate(['configure-discount'],{relativeTo: this.route, queryParamsHandling: 'preserve'});

  }
  
  onToggleChange(event: any) {
    if(event.checked){
      this.toShowCheck = 1
      let data = {
        
        createdBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        editedBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        businessHashId: this.entityHashId,
        discountStatus: 1
      }
      this.loaderService.showLoader = true
      this.loader = true
      this._apiService.addEditBillDiscount(data)
    }
    else if (!event.checked){
      this.toShowCheck = 0
      let data = {
        
        createdBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        editedBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        businessHashId: this.entityHashId,
        discountStatus: 0
      }
      this.loaderService.showLoader = true
      // this.loader = true
      this._apiService.addEditBillDiscount(data)
    }
  }

  configureDiscount(){
    this._modelRef.open(AddEditDiscountsComponent, {
      minWidth: '800px',
      data: {
        title: 'Discount Details',
        ref: this._modelRef,
        data: this.discountData[0]
      },
    });
  }


}


